module.exports = __webpack_public_path__ + "img/arr-l.474ee71c.svg";